const INTERVALO_VERIFICACAO = 5 * 60 * 1000

// Compara o commit embutido no bundle com o /version.json gerado no build, para
// que abas abertas há dias não continuem rodando uma versão antiga do sistema.
export function criarVerificadorVersao(commitAtual, buscar = fetch) {
  let versaoNova = false

  async function verificar() {
    try {
      const resposta = await buscar('/version.json', { cache: 'no-store' })
      if (!resposta.ok) {
        return
      }
      const { commit } = await resposta.json()
      if (commit && commit !== commitAtual) {
        versaoNova = true
      }
    } catch (error) {
      // Sem version.json (dev) o fallback da SPA devolve HTML: ignora.
    }
  }

  return { verificar, haVersaoNova: () => versaoNova }
}

const verificador = criarVerificadorVersao(
  typeof COMMITHASH !== 'undefined' ? COMMITHASH : null
)

export const haVersaoNova = verificador.haVersaoNova

export function iniciarVerificacaoVersao() {
  setInterval(verificador.verificar, INTERVALO_VERIFICACAO)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      verificador.verificar()
    }
  })
}
